<template>
  <ComboBoxInput
    ref="combobox"
    :value="value"
    :placeholder="placeholder"
    :is-disabled="isDisabled"
    :is-loading="isLoading || isSearching"
    :error-messages="errorMessages"
    :limit="limit"
    :options="options"
    :search-delay="1000"
    :search-threshold="1"
    :empty-text="emptyStateText"
    value-key="id"
    label-key="fio"
    display-key="fio"
    @input="$emit('input', $event)"
    @input-change="handleTypedInput"
    @change="handleChange"
    @select="$emit('select', $event)"
    @search="handleSearch"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
  >
    <template #option="{ option }">
      <div v-if="option" class="policyholder-option">
        <p class="policyholder-option__row">
          <strong>Назва компанії</strong> {{ option.fio }}
        </p>
        <p class="policyholder-option__row">
          <strong>ЄДРПОУ</strong> {{ option.identification_number }}
        </p>
      </div>
    </template>
  </ComboBoxInput>
</template>

<script>
import { mapActions } from 'vuex';
import { ComboBoxInput } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number, Object, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Введіть назву компанії',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      options: [],
      isSearching: false,
    };
  },
  components: { ComboBoxInput },
  methods: {
    ...mapActions('policyholderModule', ['searchPolicyholders']),
    handleTypedInput(value) {
      this.$emit('input', value || null);
      this.$emit('change', value || null);
    },
    handleChange(event) {
      if (!event.option) {
        this.$emit('change', null);
        return;
      }

      this.$emit('change', event.option.fio);
    },
    async handleSearch(query) {
      if (!query) {
        this.options = [];
        return;
      }

      this.isSearching = true;

      try {
        const results = await this.searchPolicyholders({
          searchText: query,
          customerType: 2,
        });
        this.options = results || [];
      } catch {
        this.options = [];
      } finally {
        this.isSearching = false;
      }
    },
    clear() {
      this.$refs.combobox?.clear();
    },
    focus() {
      this.$refs.combobox?.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.policyholder-option {
  &__row {
    margin: 0;
    font-size: 14px;
    color: #09090B;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    strong {
      font-weight: 600;
      margin-right: 8px;
    }
  }
}
</style>
